"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/portal_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalEventService = void 0;
const portal_service_pb_1 = require("./portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.event.v1.PortalEventService
 */
exports.PortalEventService = {
    typeName: "spwn.event.v1.PortalEventService",
    methods: {
        /**
         * イベント一覧の取得
         *
         * @generated from rpc spwn.event.v1.PortalEventService.GetEventsByBrandId
         */
        getEventsByBrandId: {
            name: "GetEventsByBrandId",
            I: portal_service_pb_1.PortalEventServiceGetEventsByBrandIdRequest,
            O: portal_service_pb_1.PortalEventServiceGetEventsByBrandIdResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * チケットに紐づく特典一覧の取得
         *
         * @generated from rpc spwn.event.v1.PortalEventService.GetTicketsBonusMedia
         */
        getTicketsBonusMedia: {
            name: "GetTicketsBonusMedia",
            I: portal_service_pb_1.PortalEventServiceGetTicketsBonusMediaRequest,
            O: portal_service_pb_1.PortalEventServiceGetTicketsBonusMediaResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.event.v1.PortalEventService.ReserveSeat
         */
        reserveSeat: {
            name: "ReserveSeat",
            I: portal_service_pb_1.PortalEventServiceReserveSeatRequest,
            O: portal_service_pb_1.PortalEventServiceReserveSeatResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.event.v1.PortalEventService.ReleaseSeat
         */
        releaseSeat: {
            name: "ReleaseSeat",
            I: portal_service_pb_1.PortalEventServiceReleaseSeatRequest,
            O: portal_service_pb_1.PortalEventServiceReleaseSeatResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.event.v1.PortalEventService.AssignSeat
         */
        assignSeat: {
            name: "AssignSeat",
            I: portal_service_pb_1.PortalEventServiceAssignSeatRequest,
            O: portal_service_pb_1.PortalEventServiceAssignSeatResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * チケットに紐づく連番を考慮した最大購入可能数の取得
         *
         * @generated from rpc spwn.event.v1.PortalEventService.GetTicketAvailableConsecutiveCount
         */
        getTicketAvailableConsecutiveCount: {
            name: "GetTicketAvailableConsecutiveCount",
            I: portal_service_pb_1.PortalEventServiceGetTicketAvailableConsecutiveCountRequest,
            O: portal_service_pb_1.PortalEventServiceGetTicketAvailableConsecutiveCountResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map